import requestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from './interfaces/RootState';
import {
  PaymentFrequencyStoreState,
  CompletedView,
  TermChanges
} from './interfaces/paymentFrequencyStoreState';

export const state: PaymentFrequencyStoreState = {
  completedView: null
};

export const mutations: MutationTree<PaymentFrequencyStoreState> = {
  setCompletedView(state: PaymentFrequencyStoreState, payload: CompletedView): void {
    state.completedView = payload;
  }
};

export const actions: ActionTree<PaymentFrequencyStoreState, RootState> = {
  async sendFrequencyChange({ commit }, payload: TermChanges) {
    await requestService
      .post('/api/changePaymentTerm/Submit', payload)
      .then((response) => {
        commit('setCompletedView', response.data);
      })
      .catch((error) => {
        Utility.logError(error, this);
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
